import type { RuntimeService } from '@/types';

export type RuntimeServiceGroup = {
  title: string;
  services: RuntimeService[];
};

export function isServiceReachable(service: RuntimeService): boolean {
  if (service.health?.reachable === 'yes') return true;
  if (service.health?.reachable === 'no') return false;
  return service.status === 'up' || service.status === 'degraded';
}

export function displayStatusLabel(service: RuntimeService): string {
  if (service.status === 'optional') {
    return 'OPTIONAL (not running)';
  }
  const label = service.status.charAt(0).toUpperCase() + service.status.slice(1);
  if (service.detail && service.status !== 'up') {
    return `${label} (${service.detail})`;
  }
  return label;
}

export function groupRuntimeServices(services: RuntimeService[]): RuntimeServiceGroup[] {
  const byId = new Map(services.map((s) => [s.id, s]));
  const coreIds = ['api', 'postgres', 'redis'];
  if (byId.has('scrape-workers')) coreIds.push('scrape-workers');
  else if (byId.has('scrape-worker')) coreIds.push('scrape-worker');
  if (byId.has('send-workers')) coreIds.push('send-workers');
  else if (byId.has('send-worker')) coreIds.push('send-worker');

  const pick = (ids: string[]) =>
    ids.map((id) => byId.get(id)).filter((s): s is RuntimeService => Boolean(s));

  const core = pick(coreIds);
  return core.length > 0 ? [{ title: 'Core Services', services: core }] : [];
}
